import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import * as styles from './Loading.scss';

/**
 * Reusable Loading Component
 * @function Loading
 * @param {Object} props
 * @return {ReactElement}
 */
const Loading = ({ className, spinnerClassName, spinnerStyle, style, text }) => {
  return (
    <div className={className} style={style}>
      <div className={classNames(styles.skWave, spinnerClassName)} style={spinnerStyle}>
        <div className={classNames(styles.skRect, styles.skRect1)} />
        <div className={classNames(styles.skRect, styles.skRect2)} />
        <div className={classNames(styles.skRect, styles.skRect3)} />
        <div className={classNames(styles.skRect, styles.skRect4)} />
        <div className={classNames(styles.skRect, styles.skRect5)} />
      </div>
      {text && <p className={styles.spinnerText}>{text}</p>}
    </div>
  );
};

Loading.propTypes = {
  className: PropTypes.string,
  spinnerClassName: PropTypes.string,
  spinnerStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
  text: PropTypes.string,
};

export default Loading;
